import { useSelector } from '../reduxToolkit/typedRedux';
import { banUser, isUserBanned } from '../services/services';

export function useBlockUser() {
  const event = useSelector((state) => state.common.event ?? state.admin.event);

  async function fetchIsUserBlocked(userId: string) {
    try {
      const isUserBlocked = await isUserBanned(userId, event?._id!);
      return isUserBlocked;
    } catch (err) {
      console.error(err);
    }

    return false;
  }

  async function blockUser(userId: string, boothId?: string) {
    try {
      const blockedUser = await banUser(event?._id!, 'CHAT', userId, boothId);
      return blockedUser;
    } catch (error) {
      console.error(error);
    }
  }

  return {
    fetchIsUserBlocked,
    blockUser,
  };
}
